import { render, staticRenderFns } from "./pageNotice.vue?vue&type=template&id=b8a0f88c&scoped=true"
import script from "./pageNotice.vue?vue&type=script&lang=js"
export * from "./pageNotice.vue?vue&type=script&lang=js"
import style0 from "./pageNotice.vue?vue&type=style&index=0&id=b8a0f88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a0f88c",
  null
  
)

export default component.exports